import { NodeModel } from '@minoru/react-dnd-treeview';

import { calcIndent } from './utils';

type Props = {
  node: NodeModel;
  depth: number;
};

export const CustomPlaceholder = (props: Props) => {
  const left = calcIndent(props.depth);
  return <div className="absolute bg-edit right-0 top-0 h-1 transform -translate-y-2/4" style={{ left }}></div>;
};
